import React from 'react';
import { RegisterButton } from './styles';

interface Props {
  text: string;
  onClick: VoidFunction;
  isDisabled: boolean;
  isLoading: boolean;
}

export const CheckoutButton = ({ isDisabled, onClick, text, isLoading }: Props): JSX.Element => {
  return (
    <RegisterButton
      data-testid="checkout-button"
      disabled={isDisabled}
      onClick={onClick}
      text={text}
      loading={isLoading}
    />
  );
};
